<template>
  <v-row>
    <v-col cols="12" md="6" align="stretch" height="auto">
      <v-card
        color="#f4f4f4"
        class="pa-1 ma-1 mt-0"
        align="stretch"
        height="auto"
      >
        <v-card-title dense>
          CAC Costo de Adquisición / CLV Customer Lifetime Value / CAC-to-CLV
        </v-card-title>

        <v-row align="stretch">
          <v-col cols="12">
            <v-simple-table light dense>
              <template v-slot:default>
                <thead style="background-color: #3fa9be; color: white;">
                  <tr>
                    <th
                      class="text-center"
                      style="width: 50%;color: white !important;"
                    >
                      Dato
                    </th>
                    <th class="text-center" style="color: white !important;">
                      Valor
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in datos_cac" :key="item.id">
                    <td class="ma-0 pa-0 text-center">{{ item.titulo }}</td>
                    <td
                      class="ma-0 pa-0 text-center"
                      @click="mostrarInput(0, index, 1)"
                    >
                      <div v-if="index == 0">
                        <span
                          v-show="celda_activa != 't0f' + index + 'c1'"
                          @click="mostrarInput(0, index, 1)"
                          style="width: 100%"
                          >{{ parseInt(item.valor) | dinero('$', 0) }}</span
                        >
                      </div>
                      <div v-else>
                        <span
                          v-show="celda_activa != 't0f' + index + 'c1'"
                          @click="mostrarInput(0, index, 1)"
                          style="width: 100%"
                          >{{ parseInt(item.valor) | numero }}</span
                        >
                      </div>
                      <input
                        type="text"
                        class="campo text-center"
                        v-show="celda_activa == 't0f' + index + 'c1'"
                        :ref="'t0f' + index + 'c1'"
                        v-model="datos_cac[index].valor"
                        @keydown.tab.stop.prevent="finEdicionDown(0, index, 1)"
                        @keyup.arrow-up.arrow-left="finEdicionUp(0, index, 1)"
                        @keyup.arrow-down.enter.arrow-right="
                          finEdicionDown(0, index, 1)
                        "
                        @keyup.esc="escape('t0f' + index + 'c1')"
                        @keypress="esNumero($event)"
                      />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <br />
            <v-simple-table light dense>
              <template v-slot:default>
                <thead style="background-color: #3fa9be; color: white;">
                  <tr>
                    <th
                      class="text-center"
                      style="width: 50%;color: white !important;"
                    >
                      Dato
                    </th>
                    <th class="text-center" style="color: white !important;">
                      Valor
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in datos_clv" :key="item.id">
                    <td class="ma-0 pa-0 text-center">{{ item.titulo }}</td>
                    <td
                      class="ma-0 pa-0 text-center"
                      @click="mostrarInput(1, index, 1)"
                    >
                      <div v-if="index == 0">
                        <span
                          v-show="celda_activa != 't1f' + index + 'c1'"
                          @click="mostrarInput(1, index, 1)"
                          style="width: 100%"
                          >{{ parseInt(item.valor) | dinero('$', 0) }}</span
                        >
                      </div>
                      <div v-else>
                        <span
                          v-show="celda_activa != 't1f' + index + 'c1'"
                          @click="mostrarInput(1, index, 1)"
                          style="width: 100%"
                          >{{ parseInt(item.valor) | numero }}</span
                        >
                      </div>
                      <input
                        type="text"
                        class="campo text-center"
                        v-show="celda_activa == 't1f' + index + 'c1'"
                        :ref="'t1f' + index + 'c1'"
                        v-model="datos_clv[index].valor"
                        @keydown.tab.stop.prevent="finEdicionDown(1, index, 1)"
                        @keyup.arrow-up.arrow-left="finEdicionUp(1, index, 1)"
                        @keyup.arrow-down.enter.arrow-right="
                          finEdicionDown(1, index, 1)
                        "
                        @keyup.esc="escape('t1f' + index + 'c1')"
                        @keypress="esNumero($event)"
                      />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12" align-self="center">
            <v-card>
              <table class="text-right display-1" style="width: 100%;">
                <thead>
                  <tr>
                    <th style="width: 50%;"></th>
                    <th style="width: 50%;"></th>
                  </tr>
                </thead>
                <tr>
                  <td class="pr-3">CAC:</td>
                  <td>{{ cac | dinero('$', 0) }}</td>
                </tr>
                <tr>
                  <td class="pr-3">CLV:</td>
                  <td>{{ clv | dinero('$', 0) }}</td>
                </tr>
                <tr>
                  <td class="pr-3">CAC-to-CLV:</td>
                  <td>{{ (clv - cac) | dinero('$', 0) }}</td>
                </tr>
              </table>
            </v-card>
          </v-col>
        </v-row>
      </v-card>

      <br />

      <v-card
        color="#f4f4f4"
        class="pa-1 ma-1 mb-2"
        align="stretch"
        height="auto"
      >
        <v-card-title dense>Cálculo manual de CAC-to-CLV</v-card-title>
        <v-row align="stretch">
          <v-col cols="12" align-self="center">
            <v-simple-table light dense>
              <template v-slot:default>
                <thead style="background-color: #3fa9be; color: white;">
                  <tr>
                    <th
                      class="text-center"
                      style="width: 50%; color: white !important;"
                    >
                      Dato
                    </th>
                    <th class="text-center" style="color: white !important;">
                      Valor
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in datos_cac_to_clv" :key="item.id">
                    <td class="ma-0 pa-0 text-center">{{ item.titulo }}</td>
                    <td
                      class="ma-0 pa-0 text-center"
                      @click="mostrarInput(2, index, 1)"
                    >
                      <span
                        v-show="celda_activa != 't2f' + index + 'c1'"
                        @click="mostrarInput(2, index, 1)"
                        style="width: 100%"
                        >{{ parseInt(item.valor) | dinero('$', 0) }}</span
                      >
                      <input
                        type="text"
                        class="campo text-center"
                        v-show="celda_activa == 't2f' + index + 'c1'"
                        :ref="'t2f' + index + 'c1'"
                        v-model="datos_cac_to_clv[index].valor"
                        @keydown.tab.stop.prevent="finEdicionDown(2, index, 1)"
                        @keyup.arrow-up.arrow-left="finEdicionUp(2, index, 1)"
                        @keyup.arrow-down.enter.arrow-right="
                          finEdicionDown(2, index, 1)
                        "
                        @keyup.esc="escape('t2f' + index + 'c1')"
                        @keypress="esNumero($event)"
                      />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12" align-self="center">
            <v-card>
              <table class="text-right title">
                <tr>
                  <td>CAC-to-CLV:</td>
                  <td>
                    {{
                      (parseFloat(datos_cac_to_clv[1].valor) -
                        parseFloat(datos_cac_to_clv[0].valor))
                        | dinero('$', 0)
                    }}
                  </td>
                </tr>
              </table>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <v-card
        color="#f4f4f4"
        class="pa-1 ma-1 mt-0 caption"
        align="stretch"
        height="auto"
      >
        Si querés saber más sobre lo que hacemos en BleCX y cómo podemos
        ayudarte con tu negocio o empresa contactate con nosotros
        <a
          href="http://www.blecx.com.ar/#contacto"
          target="_blank"
          rel="noopener noreferrer"
          aria-current="page"
          >aquí</a
        >
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mt-0">
        <v-card-title class="headline">¿Qué es CAC?</v-card-title>
        <v-card-subtitle class="text-justify">
          El costo de adquisición del cliente (CAC) es la cantidad de dinero
          <span class="font-weight-medium">sin considerar inflación</span>
          invertido en ventas y marketing que se requiere para captar un
          cliente. Se calcula sumando el gasto total en ventas y marketing de
          una empresa y dividiéndolo por el número de nuevos clientes. Las
          empresas pueden calcular el CAC para un período de tiempo determinado
          o todo el tiempo, y es útil para comparar la efectividad de diferentes
          tácticas y estrategias de marketing. Un CAC más bajo es mejor, ya que
          sugiere que sus equipos de marketing y ventas son eficientes y su
          estrategia actual es correcta.
        </v-card-subtitle>
      </v-card>
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mb-2">
        <v-card-title class="headline">¿Qué es CLV?</v-card-title>
        <v-card-subtitle class="text-justify"
          >El valor por ciclo de vida del cliente (VVC o CLV) equivale a los
          ingresos que un cliente promedio proporcionará a una compañía antes de
          que deje de serlo. Hay algunas ecuaciones diferentes que se usan para
          calcular CLV, pero para nuestros propósitos, usaremos la fórmula
          simple que implica multiplicar el ingreso anual promedio por la vida
          útil promedio de un cliente.</v-card-subtitle
        >
      </v-card>
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mb-2">
        <v-card-title class="headline">¿Qué es CAC-to-CLV?</v-card-title>
        <v-card-subtitle class="text-justify"
          >El Costo de adquisicion de clientes comparado con ingresos
          (CAC-to-CLV) compara el costo de adquisición del cliente con los
          ingresos que el cliente proporcionará con el tiempo. Resulta de la
          diferencia entre el CLV y el CAC (CAC-to-CLV=CLV-CAC) y ayuda a las
          empresas a saber si los clientes se retiran antes de comenzar a
          aportar ganancias a la empresa. Los líderes de experiencia de cliente
          pueden usar esta información para descubrir si necesitan invertir más
          en herramientas de soporte al cliente si este es el
          caso.</v-card-subtitle
        >
        <v-card-text>
          <a
            href="https://www.blecx.com.ar/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-img
              src="../assets/logo.svg"
              width="80"
              align="bottom"
              class="ml-auto"
            ></v-img>
          </a>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      celda_activa: '',
      datos_cac_to_clv: [
        { titulo: 'CAC', valor: null },
        { titulo: 'CLV', valor: null },
      ],
      datos_cac: [
        { titulo: 'Gastos en ventas y marketing', valor: null },
        { titulo: 'Nuevos Clientes', valor: null },
      ],
      datos_clv: [
        { titulo: 'Ingreso anual promedio por cliente', valor: null },
        { titulo: 'Ciclo de vida promedio de cliente (en años)', valor: null },
      ],
    };
  },
  filters: {
    dinero: function(value, currency, decimals) {
      var digitsRE = /(\d{3})(?=\d)/g;
      value = parseFloat(value);
      if (!isFinite(value) || (!value && value !== 0)) return '';
      currency = currency != null ? currency : '$';
      decimals = decimals != null ? decimals : 2;
      var stringified = Math.abs(value).toFixed(decimals);
      var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
      var i = _int.length % 3;
      var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? '.' : '') : '';
      var _float = decimals
        ? stringified.slice(-1 - decimals).replace('.', ',')
        : '';
      var sign = value < 0 ? '-' : '';
      return (
        sign + currency + head + _int.slice(i).replace(digitsRE, '$1.') + _float
      );
    },
    numero: function(value) {
      value = parseInt(value);
      if (!isFinite(value) || (!value && value !== 0)) return '';
      return value;
    },
    porcentaje(value) {
      value = parseFloat(value);
      if (!isFinite(value) || (!value && value !== 0)) return '';
      return ((value * 100).toFixed(2) + '%').replace('.', ',');
    },
  },

  methods: {
    calculaCes: function() {
      var suma = 0;
      var resultado = 0;
      var valor = 0;
      for (var i = 0; i < 5; i++) {
        valor = parseInt(this.datos_cac[i].valor);
        if (!isFinite(valor) || (!valor && valor !== 0)) valor = 0;
        suma += valor * (i + 1);
      }
      resultado = suma / this.total_encuestas;
      if (!isFinite(resultado) || (!resultado && resultado !== 0))
        resultado = 0;
      return resultado;
    },
    mostrarInput(tabla, fila, columna) {
      var referencia = `t${tabla}f${fila}c${columna}`;
      this.celda_activa = referencia;
      this.$nextTick(() => {
        this.$refs[referencia][0].focus();
      });
    },
    finEdicionUp(tabla, fila, columna) {
      var prox_fila = fila > 0 ? fila - 1 : 0;
      var referencia = `t${tabla}f${prox_fila}c${columna}`;
      this.finEdicion(referencia);
    },
    finEdicionDown(tabla, fila, columna) {
      var prox_fila = fila < 1 ? fila + 1 : 1;
      var referencia = `t${tabla}f${prox_fila}c${columna}`;
      this.finEdicion(referencia);
    },
    finEdicion(referencia) {
      this.celda_activa = referencia;
      this.$nextTick(() => {
        this.$refs[referencia][0].focus();
      });
    },
    escape(referencia) {
      this.celda_activa = '';
      this.$nextTick(() => {
        this.$refs[referencia][0].blur();
      });
    },
    esNumero(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  computed: {
    cac: function() {
      return (
        parseFloat(this.datos_cac[0].valor) /
        parseFloat(this.datos_cac[1].valor)
      );
    },
    clv: function() {
      return (
        parseFloat(this.datos_clv[0].valor) *
        parseFloat(this.datos_clv[1].valor)
      );
    },
  },
};
</script>

<style>
.activa {
  background-color: #eaf0f6;
}
.campo {
  width: 100%;
}

.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
}
</style>
